document.addEventListener("DOMContentLoaded", function () {
  const map = L.map("map").setView([-0.7942, -0.8822], 2); // Initial zoom to Latin America

  // Add tile layer
  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution: "© OpenStreetMap contributors",
  }).addTo(map);

  const countryData = {
    ar: { lat: -38.4161, lng: -63.6167, zoom: 4 }, // Argentina
    bo: { lat: -16.2902, lng: -63.5887, zoom: 6 }, // Bolivia
    cl: { lat: -35.6751, lng: -71.543, zoom: 5 }, // Chile
    co: { lat: 4.5709, lng: -74.2973, zoom: 6 }, // Colombia
    cr: { lat: 9.7489, lng: -83.7534, zoom: 7 }, // Costa Rica
    cu: { lat: 21.5218, lng: -77.7812, zoom: 7 }, // Cuba
    do: { lat: 18.7357, lng: -70.1627, zoom: 7 }, // Dominican Republic
    ec: { lat: -1.8312, lng: -78.1834, zoom: 6 }, // Ecuador
    sv: { lat: 13.7942, lng: -88.8965, zoom: 7 }, // El Salvador
    gt: { lat: 15.7835, lng: -90.2308, zoom: 7 }, // Guatemala
    hn: { lat: 15.1999, lng: -86.2419, zoom: 7 }, // Honduras
    mx: { lat: 23.6345, lng: -102.5528, zoom: 5 }, // Mexico
    ni: { lat: 12.8654, lng: -85.2072, zoom: 7 }, // Nicaragua
    pa: { lat: 8.5379, lng: -80.7821, zoom: 7 }, // Panama
    py: { lat: -23.4425, lng: -58.4438, zoom: 6 }, // Paraguay
    pe: { lat: -9.19, lng: -75.0152, zoom: 6 }, // Peru
    pr: { lat: 18.2208, lng: -66.5901, zoom: 8 }, // Puerto Rico
    es: { lat: 40.4637, lng: -3.7492, zoom: 6 }, // Spain
    uy: { lat: -32.5228, lng: -55.7658, zoom: 6 }, // Uruguay
    ve: { lat: 6.4238, lng: -66.5897, zoom: 6 }, // Venezuela
    br: { lat: -14.235, lng: -51.9253, zoom: 4 }, // Brazil
    us: { lat: 37.0902, lng: -95.7129, zoom: 4 }, // USA
    cn: { lat: 35.8617, lng: 104.1954, zoom: 4 }, // China
    sa: { lat: 23.8859, lng: 45.0792, zoom: 5 }, // Saudi Arabia
    ph: { lat: 12.8797, lng: 121.774, zoom: 6 }, // Philippines
    cz: { lat: 49.8175, lng: 15.473, zoom: 7 }, // Czechia
    jp: { lat: 36.2048, lng: 138.2529, zoom: 5 }, // Japan
    kr: { lat: 35.9078, lng: 127.7669, zoom: 6 }, // South Korea
    ca: { lat: 56.1304, lng: -106.3468, zoom: 4 }, // Canada
  };

  // Dropdown selection logic
  const countrySelect = document.getElementById("country-select");
  countrySelect.addEventListener("change", (event) => {
    const selectedCountry = event.target.value;
    const country = countryData[selectedCountry];

    if (country) {
      map.setView([country.lat, country.lng], country.zoom); // Update map view
    }
  });

  // Waypoints with corrected syntax
  const waypoints = [
    {
      lat: 18.2989089,
      lng: -66.0649489,
      title: "AlphaX R&D Center",
      contact: "Norm",
      city: "Caguas",
      phone: "+1 787-4704-633",
    },
    {
      title: "JJ Portworx",
      contact: "Jimmy",
      city: "Juncos",
      lat: 18.2264,
      lng: -65.9194,
      phone: "+1 (787) 203-1248",
    },
    {
      title: "FRPERFORMANCE",
      contact: "Freddy",
      city: "Sabana Grande",
      lat: 18.0808,
      lng: -66.9557,
      phone: "+1 939-228-7540",
    },
    {
      title: "NolyTuning",
      contact: "Manuel",
      city: "Hormigueros",
      lat: 18.1397,
      lng: -67.1283,
      phone: "+1 (787) 387-7078",
    },
    {
      title: "Kmandulos Motorsports",
      contact: "Elliot",
      city: "Yauco",
      lat: 18.0346,
      lng: -66.8491,
      phone: "+1 (787) 210-1688",
    },
    {
      title: "Tito Tuned",
      contact: "Bernardo",
      city: "San Lorenzo",
      lat: 18.1892,
      lng: -65.9679,
      phone: "+1 (787) 430-0707",
    },
    {
      title: "Marco Boost",
      contact: "Marco",
      city: "Bayamon",
      lat: 18.3983,
      lng: -66.1557,
      phone: "+1 (787) 370-5452",
    },
    {
      title: "Los Biraos",
      contact: "Michael",
      city: "San Sebastian",
      lat: 18.3375,
      lng: -66.9876,
      phone: "+1 (787) 231-2546",
    },
    {
      title: "RAG Custom Wire",
      contact: "Raymond",
      city: "Caguas",
      lat: 18.2341,
      lng: -66.0485,
      phone: "+1 (787) 586-1821",
    },
    {
      title: "Soto Custom Wire",
      contact: "Jose",
      city: "Guaynabo",
      lat: 18.3747,
      lng: -66.1127,
      phone: "+1 (787) 306-8837",
    },
    {
      title: "JR Performance",
      contact: "Javier",
      city: "Las Piedras",
      lat: 18.1808,
      lng: -65.8719,
      phone: "+1 (787) 600-0705",
    },
    {
      title: "Irontech",
      contact: "Willy",
      city: "Cupey",
      lat: 18.3751,
      lng: -66.0607,
      phone: "+1 (787) 452-9242",
    },
    {
      title: "El Ganzo Performance",
      contact: "Coco",
      city: "Cayey",
      lat: 18.1108,
      lng: -66.1665,
      phone: "+1 (787) 505-2782",
    },
    {
      title: "Rovira Motorcycle",
      contact: "Seller",
      city: "Vega Baja",
      lat: 18.4457,
      lng: -66.4637,
      phone: "+1 (787) 690-5468",
    },
    {
      title: "Autopiezas Lugo",
      contact: "Hugo",
      city: "San German",
      lat: 18.0814,
      lng: -67.0453,
      phone: "+1 (787) 892-4075",
    },
    {
      title: "Eluis Performance",
      contact: "Eluis",
      city: "Orocovis",
      lat: 18.2256,
      lng: -66.3922,
      phone: "+1 (787) 390-7265",
    },
    {
      title: "Cuajo Performance",
      contact: "Israel",
      city: "Sabana Grande",
      lat: 18.0708, // Slightly to the left
      lng: -66.9657,
      phone: "+1 (939) 251-9796",
    },
    {
      title: "Nasty Garage",
      contact: "Keiroy",
      city: "Hatillo",
      lat: 18.4810,
      lng: -66.8339,
      phone: "+1 (787) 638-5226",
    },
    {
      title: "Yabdi Tuner & Mech",
      contact: "Yabdi",
      city: "Aguadilla",
      lat: 18.42897914930499, // Default Puerto Rico center point (if city unknown)
      lng: -67.14789354442422,
      phone: "+1 (939) 213-6010",
    },
    {
      title: "Remnant Performance",
      contact: "Alec",
      city: "Holly Springs",
      lat: 35.643996,
      lng: -78.8734248,
      phone: "+1 336-360-8780",
    },
    {
      title: "Central Florida AlphaSpeed",
      contact: "Jesus",
      city: "Orlando",
      lat: 28.4811484,
      lng: -81.4250658,
      phone: "+1 407-233-9377",
    },
    {
      title: "BTR Car Customs",
      contact: "Sam",
      city: "Chicago",
      lat: 41.8336152,
      lng: -87.8967693,
      website: "https://www.btrcarcustoms.com/",
    },
    {
      title: "AlphaSpeedNJ",
      contact: "Zeyad",
      city: "Woodbridge",
      lat: 40.548324,
      lng: -74.3608232,
      phone: "+1 732-829-9949",
    },
    {
      title: "alphaspeedmaryland",
      contact: "Galena",
      city: "Maryland",
      lat: 38.7974057,
      lng: -78.5560094,
      website: "https://www.instagram.com/alphaspeedmaryland/",
    },
    {
      title: "Alphaspeed ATL",
      contact: "Tex",
      city: "Atlanta",
      lat: 33.7673401,
      lng: -84.5025309,
      website: "https://www.facebook.com/AlphaspeedATL/",
    },
    {
      title: "AlphaspeedKSA ",
      contact: "Yazan",
      city: "Al Saif",
      lat: 26.383714247522896,
      lng: 50.19304303625331,
      phone: "+966506910631 ",
    },
    {
      title: "AlphaSpeedPH",
      contact: "Marco",
      city: "Manila",
      lat: 14.5965777,
      lng: 120.9383602,
      website: "http://www.facebook.com/alphaspeedph/",
    },
    {
      title: "SR Comp",
      contact: "Stanislav",
      city: "Karvina",
      lat: 49.8369376,
      lng: 18.4453795,
      phone: "+420 604 931 825",
    },
    {
      title: "AlphaSpeed MIA",
      contact: "Harold",
      city: "Miami",
      lat: 25.7823244,
      lng: -80.3853486,
      phone: "+1 (786) 366-8255",
      website: "https://www.instagram.com/alphaspeedmia/",
    },
    {
      title: "AlphaSpeed China",
      contact: "Jun",
      city: "Yizheng",
      lat: 32.3473672,
      lng: 119.1652593,
      phone: "+86 182 6066 6350",
    },
    {
      title: "AlphaSpeed KW/Ontario",
      contact: "John",
      city: "Ontario",
      lat: 43.4305294,
      lng: -81.1354974,
      phone: "+1 (226) 501-3835",
    },
    {
      title: "Tuning Authority",
      contact: "John",
      city: "Guaynabo",
      lat: 18.3757,
      lng: -66.1137,
      phone: "+1 (939) 645-5036",
    },
    {
      title: "AlphaSpeed AR",
      contact: "Fabricio",
      city: "Cacho",
      lat: -26.0671484,
      lng: -62.219082,
      website: "https://www.instagram.com/fabrykosay/",
    },
    {
      title: "AlphaSpeed MW",
      contact: "Daryl",
      city: "St. Louis",
      lat: 38.6530715,
      lng: -90.3258622,
      website: "https://www.alphaspeedmidwest.com/",
    },
    {
      title: "Dialed-In Motorsports",
      contact: "Sam",
      city: "Manhattan KS",
      lat: 39.1682852,
      lng: -96.6611038,
      website: "https://dialedinmotorsports.net/",
    },
    {
      title: "AlphaSpeed Rocky Mountain",
      contact: "Jared",
      city: "Utah",
      lat: 40.5521352,
      lng: -112.3876116,
      phone: "+1 (702) 465-3544",
    },
    {
      title: "AlphaSpeed Houston",
      contact: "Donovan",
      city: "Houston",
      lat: 29.8173647,
      lng: -95.7309313,
      website: "https://www.facebook.com/AlphaspeedHoustonTx/",
    },
    {
      title: "AlphaSpeed SC",
      contact: "Corey",
      city: "Greenville",
      lat: 34.833232,
      lng: -82.4040299,
      phone: "+1-864-309-3400",
    },
    {
      title: "AlphaSpeed Central Texas",
      contact: "Josh",
      city: "Austin",
      lat: 30.3076877,
      lng: -98.067561,
      website: "https://www.facebook.com/AlphaspeedCT",
    },
    {
      title: "AlphaSped Seattle",
      contact: "Rob",
      city: "Seattle",
      lat: 47.6088285,
      lng: -122.5046027,
      phone: "+1 (702) 556-3300",
    },
    {
      title: "Black Ace Motorsports",
      contact: "Kenneth",
      city: "Torrance",
      lat: 33.8337034,
      lng: -118.3923084,
      phone: "+1 (213) 807-6326",
    },
    {
      title: "AlphaGen Performance",
      contact: "Mike",
      city: "Edmonton",
      lat: 53.5267713,
      lng: -113.6575409,
      website: "https://www.alphagenperformance.com/",
    },
    // === CORRECTED ENTRIES ADDED BELOW ===
    {
      title: "Yero's Autoparts",
      contact: "Yero",
      city: "Hatillo",
      lat: 18.4812411,
      lng: -66.833909, // Comma was missing here
      phone: "+1 (787) 680-8006",
    },
    {
      title: "Nightmare Performance",
      contact: "Jason Lopez",
      city: "Orlando",
      lat: 28.4812072,
      lng: -81.4251947, // Comma was missing here
      phone: "+1 (689) 298-9255",
    },
    {
      title: "LocospeedPTY",
      contact: "Loco",
      city: "Panama",
      lat: 9.0202087,
      lng: -79.5002055, // Comma was missing here
      phone: "+507 6219-2471",
    },
    {
      title: "Raceway Performance",
      contact: "Pedro",
      city: "Panama Oeste",
      lat: 8.9577235,
      lng: -79.7322183, // Comma was missing here
      phone: "+507 6435-0031",
    },
  ];

  // Create markers with popups
  waypoints.forEach((point) => {
    const popupContent = `
            <strong>${point.title}</strong><br>
            Contact: ${point.contact}<br>
            City: ${point.city || "Unknown"}<br>
            ${
              point.phone
                ? `Phone: <a href="tel:${point.phone}">${point.phone}</a><br>`
                : ""
            }
            ${
              point.website
                ? `Website: <a href="${point.website}" target="_blank">${point.website}</a>`
                : ""
            }
        `;

    L.marker([point.lat, point.lng]).addTo(map).bindPopup(popupContent);
  });
});